<template lang="html">
	<div class="chat-wrapper" >
		<div class="chat-sidebar">
			<!-- start sidebar body -->
			<div class="chat-sidebar-body">
			    <!-- <div class="flex-fill pd-y-20 pd-x-10">
					<div class="d-flex align-items-center justify-content-between pd-x-10 mg-b-10">
						<span class="tx-10 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1">All Channels</span>
					</div>
					<nav id="allChannels" class="nav flex-column nav-chat mg-b-20">
						<a @click="changeData(form.receptionid)" class="nav-link" v-bind:class="(form.receptionname == chatRoomName) ? 'active' : ''" v-for="(form, i) in chatRooms">#{{form.receptionname}}</a>
					</nav>
				</div> -->
				<!-- <div class="flex-fill pd-y-20 pd-x-10 bd-t"> -->
				<div class="flex-fill pd-y-20 pd-x-10">
					<p class="tx-10 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10 mg-b-10">Members List</p>
					<div class="chat-member-list">
						<div class="media" v-for="(form, i) in memberList">
							<div class="avatar avatar-sm avatar-online" v-if="form.id == userid"><span class="avatar-initial rounded-circle">{{form.name.substr(0,1)}}</span></div>
							<div class="avatar avatar-sm" v-else><span class="avatar-initial rounded-circle">{{form.name.substr(0,1)}}</span></div>
							<div class="media-body mg-l-10">
							<h6 class="mg-b-0">{{form.name}}</h6>
							</div><!-- media-body -->
						</div><!-- media -->
					</div><!-- chat-msg-list -->
				</div>
			</div><!-- chat-sidebar-body -->
		</div><!-- chat-sidebar -->

		<div class="chat-content mg-l-1-f">
			<div class="chat-content-header">
				<h6 id="channelTitle" class="mg-b-0">#{{chatRoomName}}</h6>
			</div><!-- chat-content-header -->

			<div class="chat-content-body">
				<vueCustomScrollbar class="chatting-height" id='chat'>
					<div class="chat-group" ref="chatInfo">
						<div v-for="(form, i) in readData">
							<div class="chat-group-divider mt-3 mb-3" v-if="form.createDate.length > 0">{{form.createDate}}</div>
							<div class="media" v-if="form.userId != userid">
								<div class="avatar avatar-sm" v-if="form.userName.length > 0"><span class="avatar-initial rounded-circle">{{form.userName.substr(0,1)}}</span></div>
								<div class="avatar avatar-sm" v-else></div>
								<div class="media-body">
									<h6>{{form.userName}}</h6>
									<p>{{form.message}}<small class='ml-2' v-if="form.createTime.length > 0">{{form.createTime}}</small></p>
								</div><!-- media-body -->
							</div><!-- media -->
							<div class="media" v-else>
								<div class="media-body tx-right-f mr-4">
									<h6>{{form.userName}}</h6>
									<p><small class='mr-2' v-if="form.createTime.length > 0">{{form.createTime}}</small>{{form.message}} </p>
								</div><!-- media-body -->
								<div class="avatar avatar-sm avatar-online" v-if="form.userName.length > 0"><span class="avatar-initial rounded-circle">{{form.userName.substr(0,1)}}</span></div>
								<div class="avatar avatar-sm" v-else></div>
							</div><!-- media -->
						</div>
					</div><!-- chat-group -->
				</vueCustomScrollbar>
			</div><!-- chat-content-body -->

			<div class="chat-content-footer">
				<input type="text" v-model="message" class="form-control align-self-center bd-0" placeholder="Message" @keyup.enter="sendMessage">
				<nav class='svg-cursor'>
					<feather type="send" class="wd-25 hd-25 valign-middle-f svg_overflow"  @click="sendMessage"></feather>
				</nav>
			</div><!-- chat-content-footer -->
		</div><!-- chat-content -->
	</div><!-- chat-wrapper -->
</template>
<script>
	import {bus} from '../../main';
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	import moment from "moment";
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	
	export default {
		name: 'Chat',
		props: ['properties'],
		data() {
			return {
				readData: [], // 메시지 확인 데이터
				unReadData: [], // 메시지 미확인 데이터

				receptionid : '', // reception uuid
				companyid: '', // company uuid
				userid: '', // user uuid 
				username: '', // user name
				chatRoomName: '',
				message: '',
                memberList: [], // chat member
				chatRooms:[], //chat rooms
				
				receptionData:[],
			}
		},
		beforeDestroy(){
			bus.$off('receptid');
			bus.$off('companyid');
			bus.$off('userinfo');
		},
		created(){
			bus.$on('receptid', (data)=>{
				this.receptionid = data;
				this.memberList = [];
                this.memberList.push({id: this.userid, name: this.username});
				this.setEventData();
				this.classifyData();
			});
			bus.$on('companyid', (data)=>{
                this.companyid = data;
			});
			bus.$on('userinfo', (data)=>{
				this.userid = data.id;
                this.username = data.userName;
			});
		},
		mounted() {
		},
		components: {
			moment,
			vueCustomScrollbar
		},
		methods: {
			/*
			* Chat Event Data Setting
			*/
			setEventData() {
                this.message = '';
				// 동시에 채팅창을 열고 있을때, 채팅창 설정을 위하여 가상의 emit 실행
				this.$socket.emit('chat', {receptionId: this.receptionid, setEvent:true});
				// 레이어 채팅창을 열고 닫으면 계속적으로 $chat에 반복적으로 적제되어 마지막 값만 넣어주기 위한 초기화 설정
				if(!common.isNull(this.$socket._callbacks.$chat)) {
					this.$socket._callbacks.$chat = this.$socket._callbacks.$chat[this.$socket._callbacks.$chat.length]
				}
				this.$socket.on('chat', (data)=> {
					if (data.length > 0) {
                        this.realSettingData(data[0]);
                    }
				});

			},
			/*
			* classifyData
			*/
			async classifyData() { 
				var params = {receptionId: this.receptionid};
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/chats", request)
				.then(res => {
                    this.readData = res.data.data;
					this.chatRooms = res.data.chatRooms;
					this.receptionData = res.data.receptionData;

					this.chatRooms.sort((a,b)=>{
						return b.receptionname.substr(b.receptionname.length-4,4) - a.receptionname.substr(a.receptionname.length-4,4)
					}) 
				})
                .catch(err => {console.log(err);});
				this.setttingData();
            },
              async changeData(id) { 
                this.receptionid = id;
				var params = {receptionId: this.receptionid};
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/chats", request)
				.then(res => {
					this.readData = res.data.data;
					this.chatRooms = res.data.chatRooms;
					this.receptionData = res.data.receptionData;

					this.chatRooms.sort((a,b)=>{
						return b.receptionname.substr(b.receptionname.length-4,4) - a.receptionname.substr(a.receptionname.length-4,4)
					}) 
				})
				.catch(err => {console.log(err);});
				this.setttingData();
			},
			/*
			* refactoring data
			*/
			async setttingData() {
				let thisDate = '';
				let thisTime = '';
				let userId = '';
				this.chatRoomName = this.receptionData.receptionNo;
				this.readData.forEach((a, b)=>{
					if(b === 0) {
						thisDate = a.createDate;
						a.createDate = moment(a.createDate).format('MMMM DD, YYYY');
						thisTime = a.createTime;
						userId = a.userId;
						this.memberList.push({id: a.userId, name: a.userName});
					}else{
						if(thisDate == a.createDate) {
							a.createDate = '';
						}else{
							thisDate = a.createDate;
							a.createDate = moment(a.createDate).format('MMMM DD, YYYY');
						}
						if(thisTime == a.createTime) {
							this.readData[b-1].createTime = '';
						}else{
							thisTime = a.createTime;
						}
						if(userId == a.userId) {
							if(a.createDate.length === 0) a.userName = '';
						}else{
							userId = a.userId;
							this.memberList.push({id: a.userId, name: a.userName});
						}
                    }
				});
				this.memberData();
				this.scrollToEnd()
			},
			/*
			* Member List
			*/
			async memberData() {
				this.memberList.sort((a,b)=>{
					if(a.name<b.name) {return -1;}
					else if (a.name===b.name) {return 0;}
					else {return 1;}
				});
				let memberid = '';
				let splicemember = [];
				this.memberList.forEach((a,b)=>{
					if(b===0){
						memberid = a.id;
					}else{
						if(memberid == a.id) splicemember.push(b)
						else memberid = a.id
					}
				});
				splicemember.sort((a,b)=>{
					return b-a;
				});
				splicemember.forEach(a=>{
					this.memberList.splice(a,1);
				});
			},
			/*
			* chat real-time refactoring data
			*/
			async realSettingData(data) {
				let thisDate = '';
				let thisTime = '';
				let userId = '';
                this.memberList.push({id: data.userId, name: data.userName});
                if (this.readData.length != 0) {
                    if(moment().format('YYYY-MM-DD') === data.createDate) data.createDate = '';
                    else moment(data.createDate).format('MMMM DD, YYYY');
                    if(this.readData[this.readData.length - 1].createTime === data.createTime) this.readData[this.readData.length - 1].createTime = '';
                    if(this.readData[this.readData.length - 1].userId === data.userId) {
                        if (data.createDate.length === 0) data.userName = '';
                    }
                }
               

                this.readData.push(data);
				this.memberData();
				this.scrollToEnd()
			},
			/*
			* sendMessage
			*/
			async sendMessage(){
				if(this.message.trim().length > 0){
                    var params = {receptionId: this.receptionid, message: this.message};
					this.$axios.post(this.$apiHost+'/chats', params)
					.then(res=>{
						this.$socket.emit('chat', {receptionId: this.receptionid, companyId: this.companyid});
						if (this.readData.length == 0) {
							this.classifyData();
						}
                    }).catch(err=>{console.log(err)});
                    
				}
				this.message = '';

			},
			/*
			* close Chat Room
			*/
			async disconnection(){
				this.$socket.close();
			},

			scrollToEnd() {
				setTimeout (() => {
                    var container = document.querySelector('#chat');
					container.scrollTop = this.$refs.chatInfo.scrollHeight;
				}, 10 * 20);
			}
		},
		computed: {
		},
		watch: {
		},
	}
</script>


// WEBPACK FOOTER //
// src/views/Common/Chat.vue